<template>
  <div>
<h2>学校名称：{{name}}</h2>
<h2>学校地址：{{address}}</h2>
 <router-link replace to="/School/login">学校嵌套的效果</router-link>
 <router-view/> 
<button @click="shownames">这是一个按钮</button>
  </div>
</template>

<script>
export default {
name:"School",
beforeDestroy(){
console.log("学校组件被销毁了")
},
data(){
    return{ 
    name:"河南工程学校",
    address:"河南"
    }

},
  methods:{
      shownames(){
        alert(this.name)
      }  
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/study/study3/School.vue